import React from 'react';
import PropTypes from 'prop-types';
import Game from './game';
import Training from './training';

class Event extends React.Component {
  splitEventsForTypes = (event, t_controls) => {
    switch (event.type) {
      case 'Game':
        return <Game game={event} t_controls={t_controls}/>
      case 'Training':
        return <Training training={event} t_controls={t_controls}/>
      default:
        return null;
    }
  }

  render() {
    const { event, t_controls } = this.props;

    return this.splitEventsForTypes(event, t_controls);
  }
}

Event.propTypes = {
  event: PropTypes.object.isRequired,
  t_controls: PropTypes.object.isRequired,
};

export default Event;
